import { Fragment } from 'react'
import Grid from '@mui/material/Grid'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Box, Container } from '@mui/material'
import { Link } from 'react-router-dom'
import { formatter } from '../../utils/auxFunc'
import './ItemsList.css'
import Spinner from '../../containers/Spinner'

const ItemsList = ({ showPrice, products, showCategoryTexts }) => {
  return Boolean(products) ? (
    <Container maxWidth="xl" sx={{ marginBottom: '5rem' }}>
      <Container>
        {products?.length > 0 ? (
          <Fragment>
            <Box className="imgCategoryContainer">
              <Grid container spacing={2}>
                {products?.map((product) => (
                  <Grid
                    className="gridContainer"
                    key={product.idProduct}
                    item
                    xs={6}
                    md={3}
                    mb={4}
                  >
                    <Link
                      className="linkGridHome"
                      to={`/itemDetail/${product.idProduct}`}
                    >
                      <CardMedia
                        className="imgGrid"
                        component="img"
                        image={product.img}
                        alt={product.name}
                      />
                      <Typography
                        className="nameCard"
                        sx={{ textAlign: 'left' }}
                        variant="body1"
                        style={{ fontFamily: 'Quicksand' }}
                      >
                        {product.name}
                      </Typography>
                      <Typography
                        className="nameCard"
                        sx={{ textAlign: 'left' }}
                        variant="body1"
                        style={{ fontFamily: 'Quicksand' }}
                      >
                        {`SKU: ${product.sku}`}
                      </Typography>

                      {!product.isPromotion ? (
                        <Typography
                          sx={{
                            textAlign: 'left',
                            fontWeight: 'bold',
                            mb: 3.5
                          }}
                          color="text.primary"
                          variant="h3"
                        >
                          {showPrice &&
                            formatter().format(
                              product.price * product.dolarValue
                            )}
                        </Typography>
                      ) : (
                        <Box className="price-box-home">
                          <Typography
                            sx={{
                              textAlign: 'left',
                              fontWeight: 'bold',
                              mb: 3.5
                            }}
                            color="text.primary"
                            variant="h3"
                            className="price-home"
                          >
                            {/* {auth &&
                          formatter().format(
                            Boolean(product.voidedPrice)
                              ? product.voidedPrice * product.dolarValue
                              : (1 + product.priceIncreasePercentage) *
                                  (product.price * product.dolarValue)
                          )} */}
                            {showPrice &&
                              formatter().format(
                                product.markedPrice * product.dolarValue
                              )}
                          </Typography>
                          <Typography
                            sx={{
                              textAlign: 'left',
                              fontWeight: 'bold',
                              mb: 3.5,
                              ml: 2
                            }}
                            color="red"
                            variant="h3"
                          >
                            {showPrice &&
                              formatter().format(
                                product.price * product.dolarValue
                              )}
                          </Typography>
                        </Box>
                      )}
                    </Link>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Fragment>
        ) : showCategoryTexts ? (
          <Box className="noStock">
            <Typography variant="h1">
              Categoría actualmente sin productos
            </Typography>
            <Typography variant="h3">
              Consultanos cuando estarán disponibles.
            </Typography>
          </Box>
        ) : (
          <Box className="noStock">
            <Typography variant="h1">
              Producto sin stock o búsqueda inexistente
            </Typography>
            <Typography variant="h3">
              Verifique ingresar correctamente el código o nombre del producto
            </Typography>
            <Typography variant="h3">
              Consultanos cuando estarán disponibles.
            </Typography>
          </Box>
        )}
      </Container>
    </Container>
  ) : (
    <Spinner />
  )
}

export default ItemsList
